import { carousel } from './modules/carousel';
import { header } from './modules/header';
import { scrollAddClass } from './modules/scrollAddClass';
import { smooth } from './modules/smooth';

carousel();
header();
scrollAddClass();
smooth();